import React, { Component, useEffect, useState } from "react";
import mammoth from 'mammoth';
import { getTermsAndCondition_V1 } from "../api/apiManager";
import { View, Image, TouchableOpacity, Text, Linking, ScrollView, } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, } from "rn-responsive-styles";

const CDocxViewer = (props) => {
  const type = props?.type || ""
  const setTncModalVisible = props?.visibility
  const [htmlContent, setHtmlContent] = useState('');
  const styles = useStyles();

  const getTnc = () => {
      const params = {
        "docName": type,
        "docType": "docx"
      };
      getTermsAndCondition_V1(params).then(res => {
        convertBase64ToHtmlFormat(`data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${res}`)
      }).catch(err => {
      })
  }
  useEffect(() => { getTnc() }, [])

  const isValidBase64String = (str) => {
    try {
      // Decode the string to ensure it's valid base64
      atob(str);
      return true;
    } catch (err) {
      return false;
    }
  };
  const convertBase64ToHtmlFormat = async (param) => {
    // Remove the data URI prefix if it exists
    const base64String = param.split(',').pop();

    if (!isValidBase64String(base64String)) {
      console.error('Invalid base64 string');
      return;
    }
    try {
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const arrayBuffer = byteArray.buffer;
      const result = await mammoth.convertToHtml({ arrayBuffer });

      setHtmlContent(result.value);
    } catch (error) {
      console.error('Error converting DOCX to HTML:', error);
    }
  };

  return (
    <View style={styles.overlayViewStyle}>
      <View style={styles.overlayContentStyle}>
        <TouchableOpacity
          onPress={() => {
            setTncModalVisible(false);
          }}
          style={{ padding: 20 }}
        >
          <Text>{"X"}</Text>
        </TouchableOpacity>
        <ScrollView horizontal={true}>
          <ScrollView showsVerticalScrollIndicator={false}>
            <View style={styles.pdfViewStyle}>
              {htmlContent &&
                <div style={{ margin: "50px" }} className="doc-content-wrapper">
                  <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                </div>}
            </View>
          </ScrollView>
        </ScrollView>
      </View>
    </View>
  )



}

const useStyles = CreateResponsiveStyle({

  overlayViewStyle: {
    position: "absolute",
    zIndex: 9999,
    backgroundColor: "rgba(52,52,52,0.9)",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    borderRadius: 10,
    alignItems: "center"
  },
  overlayContentStyle: {
    width: "80%",
    height: "100%",
    backgroundColor: "white",
    borderRadius: 15,

  },
  pdfViewStyle: {
    height: "60%",
    width: "100%",
  },


},
  {
    [DEVICE_SIZES.LG]: {


    },
    [DEVICE_SIZES.MD]: {

    },
    [DEVICE_SIZES.SM]: {

    },
    [DEVICE_SIZES.XS]: {
      overlayContentStyle: {
        width: "90%",
      },
      pdfViewStyle: {
        alignItems: null,
      },

    }
  }

)
export default CDocxViewer;

//  {tncModalVisible && <CDocxViewer type = "FF_TRIP_TNC" visibility={setTncModalVisible}/>}